/* This file was generated automatically. Do not edit manually. */

export enum ReservationState {
    Undefined = 'Undefined',
    Future = 'Future',
    ToBeCheckedIn = 'ToBeCheckedIn',
    CheckedIn = 'CheckedIn',
    CheckedInOnline = 'CheckedInOnline',
    CheckInMissed = 'CheckInMissed',
    ToBeCheckedOut = 'ToBeCheckedOut',
    CheckedOutOnline = 'CheckedOutOnline',
    CheckOutMissed = 'CheckOutMissed',
    Past = 'Past',
    Cancelled = 'Cancelled',
    Optional = 'Optional',
    Inquired = 'Inquired',
}
